import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  UpdateOverrideInput,
  UpdateOverrideVariables,
  UpdateOverrideMutationResponse,
} from '../types';

const updateOverrideMutation = gql`
  mutation UpdateOverride($input: UpdateOverrideInput!) {
    payrollUpdateOverride(input: $input) {
      code
      success
      message
      data
    }
  }
`;

export const updateOverride = (
  input: UpdateOverrideInput,
): Promise<UpdateOverrideMutationResponse> => {
  return graphQLApi<UpdateOverrideMutationResponse, UpdateOverrideVariables>({
    query: updateOverrideMutation,
    queryVariables: {
      input,
    },
  });
};

